export const LOAD_ACTION = '@UserForm/Load/LOAD'
export const SUCCESS_ACTION = '@UserForm/Load/SUCCESS'
export const ERROR_ACTION = '@UserForm/Load/ERROR'
export const RESET_ACTION = '@UserForm/Load/RESET'
